import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {contactContent.intro}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {contactContent.items.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-500">{item.label}</div>
                  <div className="text-sm font-medium text-foreground-900 truncate">{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}